<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{
            datamodal.tipoReporte === "saldo"
              ? "Saldo cuenta"
              : "Movimiento cuenta"
          }}
        </p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div id="printdetalle" class="table-container">
          <strong>{{ empresa.nombre }}</strong>
          <small
            >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
          >
          <br />
          <strong>
            {{
              datamodal.tipoReporte === "saldo"
                ? "Detalle por tercero"
                : "Movimiento"
            }}
            de la cuenta
            <span class="fontMono">{{ datamodal.codigoCuenta }}</span>
            {{ datamodal.nombreCuenta }}
          </strong>
          - {{ fecha(period) }}
          <table
            v-show="datamodal.tipoReporte === 'saldo'"
            style="width: 100%; font-size: 14px"
            class="fontMono"
          >
            <tr style="background-color: #f3f3f3">
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              >
                Nit
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              >
                D. Ref
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                CCosto
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                Saldo Inicial
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                Debito
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                Credito
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                Saldo Final
              </th>
            </tr>
            <tr v-for="(saldo, index) in datamodal.detalles" :key="index">
              <!--<td>{{saldo.tieneTercero ? saldo.codigoNit : '' }}</td>-->
              <td style="padding: 2px" :style="styleTr(saldo)">
                <span
                  >{{
                    saldo.tieneTercero ? saldo.codigoNit : "" | textnumber()
                  }}
                  <small>{{
                    saldo.tieneTercero ? saldo.nombreTercero : ""
                  }}</small></span
                >
              </td>
              <td
                style="padding: 2px 2px 2px 8px; text-align: right"
                :style="styleTr(saldo)"
              >
                {{ saldo.tieneDocRef ? saldo.docRef : "" }}
              </td>
              <td
                style="padding: 2px 2px 2px 8px; text-align: right"
                :style="styleTr(saldo)"
              >
                {{ saldo.ccostos ? saldo.ccostos : "" }}
              </td>
              <td
                style="padding: 2px 2px 2px 8px; text-align: right"
                :style="styleTr(saldo)"
              >
                {{ saldo.saldoInicial ? saldo.saldoInicial : 0 | number(2) }}
              </td>
              <td
                style="padding: 2px 2px 2px 8px; text-align: right"
                :style="styleTr(saldo)"
              >
                {{ saldo.debito ? saldo.debito : 0 | number(2) }}
              </td>
              <td
                style="padding: 2px 2px 2px 8px; text-align: right"
                :style="styleTr(saldo)"
              >
                {{ saldo.credito ? saldo.credito : 0 | number(2) }}
              </td>
              <td
                style="padding: 2px 2px 2px 8px; text-align: right"
                :style="styleTr(saldo)"
              >
                {{
                  (saldo.saldoInicial + saldo.debito - saldo.credito)
                    | number(2)
                }}
              </td>
            </tr>
            <tr style="background-color: #f3f3f3">
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: left;
                "
              >
                TOTAL
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              ></th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              ></th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                {{
                  datamodal.totales
                    ? datamodal.totales.saldoInicial
                    : 0 | number(2)
                }}
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                {{
                  datamodal.totales ? datamodal.totales.debito : 0 | number(2)
                }}
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                {{
                  datamodal.totales ? datamodal.totales.credito : 0 | number(2)
                }}
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                {{
                  datamodal.totales
                    ? datamodal.totales.saldoInicial +
                      datamodal.totales.debito -
                      datamodal.totales.credito
                    : 0 | number(2)
                }}
              </th>
            </tr>
          </table>
          <table
            v-show="datamodal.tipoReporte === 'movimiento'"
            style="width: 100%; font-size: 14px"
            class="fontMono"
          >
            <tr style="background-color: #f3f3f3">
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              >
                Comp
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                Doc
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                Día
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px 2px 2px 8px;
                "
              >
                Descripción
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                S. Ini
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                Debito
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                Credito
              </th>
              <th
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                S. Fin
              </th>
            </tr>
            <tr v-for="(mov, index) in datamodal.detalles" :key="index">
              <td :style="styleTr1(mov)" style="padding: 2px">
                {{ mov.codComprobante }}
              </td>
              <td
                :style="styleTr1(mov)"
                style="padding: 2px 2px 2px 8px; text-align: right"
              >
                {{ mov.documento }}
              </td>
              <td
                :style="styleTr1(mov)"
                style="padding: 2px 2px 2px 8px; text-align: right"
              >
                <small>{{ mov.fecha ? mov.fecha : "" | dia() }}</small>
              </td>
              <td
                :style="styleTr1(mov)"
                style="padding: 2px 2px 2px 8px; text-align: left"
              >
                <strong>{{ mov.saldo ? "Total:" : "" }}</strong
                ><small
                  >{{ mov.descripcion }}
                  <strong
                    >{{ mov.tieneTercero ? mov.codigoNit : ""
                    }}{{ mov.tieneTercero ? ":" : "" }}</strong
                  >
                  {{ mov.tieneTercero ? mov.nombreTercero : "" }}
                  <strong>{{
                    mov.tieneDocRef ? "Documento Ref: " : ""
                  }}</strong>
                  {{ mov.tieneDocRef ? mov.docRef : "" }}</small
                >
              </td>
              <td
                :style="styleTr1(mov)"
                style="padding: 2px 2px 2px 8px; text-align: right"
              >
                <strong v-show="mov.saldo">{{
                  mov.saldo ? mov.saldoInicial : "" | number(2)
                }}</strong>
              </td>
              <td
                :style="styleTr1(mov)"
                style="padding: 2px 2px 2px 8px; text-align: right"
              >
                <span v-show="!mov.saldo">{{ mov.debito | number(2) }}</span
                ><strong v-show="mov.saldo">{{
                  mov.debito | number(2)
                }}</strong>
              </td>
              <td
                :style="styleTr1(mov)"
                style="padding: 2px 2px 2px 8px; text-align: right"
              >
                <span v-show="!mov.saldo">{{ mov.credito | number(2) }}</span
                ><strong v-show="mov.saldo">{{
                  mov.credito | number(2)
                }}</strong>
              </td>
              <td
                :style="styleTr1(mov)"
                style="padding: 2px 2px 2px 8px; text-align: right"
              >
                <strong v-show="mov.saldo">{{
                  mov.saldo ? mov.saldoInicial + mov.mvto : "" | number(2)
                }}</strong>
              </td>
            </tr>
          </table>
        </div>
        <!-- Content ... -->
      </section>
      <footer class="modal-card-foot">
        <button class="button is-link" @click="imprimir">
          <span class="icon is-small">
            <span class="material-icons">print</span>
          </span>
          <span>Imprimir</span>
        </button>
        <button type="submit" class="button is-light" @click="descargarDetalle">
          <span class="icon is-small">
            <span class="material-icons">archive</span>
          </span>
          <span>Descargar</span>
        </button>
        <button class="button" @click="close">
          <span class="icon is-small">
            <span class="material-icons">cancel</span>
          </span>
          <span>Cancelar</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
const XLSX = require("xlsx");
export default {
  props: {
    show: Boolean,
    datamodal: Object,
    period: Object,
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    descargarDetalle() {
      const _this = this;
      const data2export = [];
      if (this.datamodal.tipoReporte === "saldo") {
        for (let index in this.datamodal.detalles) {
          const saldo = _this.datamodal.detalles[index];
          const data2push = {
            "Codigo cuenta":
              saldo.clase === "subTotales"
                ? "Subtotal"
                : _this.datamodal.codigoCuenta,
            "Nombre cuenta": _this.datamodal.nombreCuenta,
            Nit: `${saldo.tieneTercero ? saldo.codigoNit : ""} - ${
              saldo.tieneTercero ? saldo.nombreTercero : ""
            }`,
            dref: saldo.tieneDocRef ? saldo.docRef : "",
            Ccosto: saldo.tieneCcosto ? saldo.ccostos : "",
            S_Inicial: saldo.saldoInicial ? saldo.saldoInicial : 0,
            Debito: saldo.debito ? saldo.debito : 0,
            Credito: saldo.credito ? saldo.credito : 0,
            S_Final: saldo.saldoInicial + saldo.debito - saldo.credito,
          };
          data2export.push(data2push);
        }
        const data2pushTotal = {
          "Codigo cuenta": _this.datamodal.codigoCuenta,
          "Nombre cuenta": _this.datamodal.nombreCuenta,
          Nit: "TOTAL",
          dref: "",
          Ccosto: "",
          S_Inicial: this.datamodal.totales
            ? this.datamodal.totales.saldoInicial
            : 0,
          Debito: this.datamodal.totales ? this.datamodal.totales.debito : 0,
          Credito: this.datamodal.totales ? this.datamodal.totales.credito : 0,
          S_Final: this.datamodal.totales
            ? this.datamodal.totales.saldoInicial +
              this.datamodal.totales.debito -
              this.datamodal.totales.credito
            : 0,
        };
        data2export.push(data2pushTotal);
      } else if (this.datamodal.tipoReporte === "movimiento") {
        for (let index in this.datamodal.detalles) {
          const mov = _this.datamodal.detalles[index];
          const data2push = {
            "Codigo cuenta": mov.saldo ? "Total" : _this.datamodal.codigoCuenta,
            "Nombre cuenta": _this.datamodal.nombreCuenta,
            Comprobante: mov.codComprobante,
            Documento: mov.documento,
            Fecha: mov.fecha,
            Descripcion: mov.saldo ? "Total" : mov.descripcion,
            Nit: mov.tieneTercero ? mov.codigoNit : "",
            Nombre: mov.tieneTercero ? mov.nombreTercero : "",
            DocRef: mov.tieneDocRef ? mov.docRef : "",
            S_Inicial: mov.saldo ? mov.saldoInicial : "",
            Debito: mov.debito,
            Credito: mov.credito,
            S_Final: mov.saldo ? mov.saldoInicial + mov.mvto : "",
          };
          data2export.push(data2push);
        }
      }
      let data = XLSX.utils.json_to_sheet(data2export);
      const workbook = XLSX.utils.book_new();
      const filename = `${
        this.datamodal.tipoReporte === "saldo" ? "Bce cuenta" : "Mvto cuenta"
      } ${this.datamodal.codigoCuenta} ${this.fecha1(this.period)}`;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    styleTr(item) {
      if (item.clase === "subTotales") {
        return {
          "padding-bottom": "20px",
          "font-weight": "bold",
          "border-top": "1px solid #dbdbdb",
          color: "black",
        };
      }
    },
    styleTr1(item) {
      if (item.saldo) {
        return {
          "font-weight": "bold",
          "border-top": "1px solid #dbdbdb",
          "border-bottom": "1px solid #dbdbdb",
          color: "black",
          "background-color": "#f3f3f3",
        };
      } else {
        return {
          "border-top": "1px solid #dbdbdb",
        };
      }
    },
    fecha1(p) {
      const month = p.months[0];
      const namesmonths = {
        1: "ene",
        2: "feb",
        3: "mzo",
        4: "abr",
        5: "myo",
        6: "jun",
        7: "jul",
        8: "ago",
        9: "sep",
        10: "oct",
        11: "nov",
        12: "dic",
      };
      return `${namesmonths[month]}-${p.year}`;
    },
    fecha(p) {
      const month = p.months[0];
      const namesmonths = {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre",
      };
      return `${namesmonths[month]} de ${p.year}`;
    },
    imprimir() {
      // functions.imprimir(this.data.comprobante.nombre,this.data.documento,this.data.mes.codigo);
      this.$print("printdetalle", {
        name: `Detalle ${this.datamodal.codigoCuenta} ${this.datamodal.nombreCuenta} ${this.period}`,
      });
    },
    close() {
      this.$emit("showmodalsbalance", false);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/modals/SaldoModalBalance2.vue